export type VoicesCalendarView = "day" | "week" | "month";

const pad = (value: number) => String(value).padStart(2, "0");

export const dayKey = (day: Date) =>
  `${day.getFullYear()}-${pad(day.getMonth() + 1)}-${pad(day.getDate())}`;

export const addDays = (day: Date, days: number) => {
  const next = new Date(day);
  next.setDate(next.getDate() + days);
  return next;
};

export const startOfWeek = (day: Date) => {
  const monday = new Date(day.getFullYear(), day.getMonth(), day.getDate());
  return addDays(monday, -((monday.getDay() + 6) % 7));
};

export const visibleDays = (view: VoicesCalendarView, anchor: Date): Date[] => {
  if (view === "day") {
    return [new Date(anchor.getFullYear(), anchor.getMonth(), anchor.getDate())];
  }
  if (view === "week") {
    const monday = startOfWeek(anchor);
    return Array.from({ length: 7 }, (_, index) => addDays(monday, index));
  }
  const first = new Date(anchor.getFullYear(), anchor.getMonth(), 1);
  const last = new Date(anchor.getFullYear(), anchor.getMonth() + 1, 0);
  const start = startOfWeek(first);
  const days: Date[] = [];
  for (let day = start; day <= last || days.length % 7 !== 0; day = addDays(day, 1)) {
    days.push(day);
  }
  return days;
};

export const shiftAnchor = (view: VoicesCalendarView, anchor: Date, step: number) => {
  if (view === "day") return addDays(anchor, step);
  if (view === "week") return addDays(anchor, 7 * step);
  return new Date(anchor.getFullYear(), anchor.getMonth() + step, 1);
};

/** The same time of day on another date, as the local "YYYY-MM-DDTHH:mm" the API takes. */
export const movedTime = (scheduledAt: string, targetDayKey: string) =>
  `${targetDayKey}T${scheduledAt.slice(11, 16)}`;
